// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.internetmoney",
    name: "Internet Money Wallet",
    homepage: "https://internetmoney.io",
    image_id: "204b2240-5ce4-4996-6ec4-f06a22726900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/id1641771042",
        android: "https://play.google.com/store/apps/details?id=com.internetmoneywallet.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/ckklhkaabbmdjkahiaaplikpdddkenic",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "internetmoney://",
        universal: "https://internetmoney.io",
    },
    desktop: {
        native: null,
        universal: "https://internetmoney.io",
    },
};
//# sourceMappingURL=index.js.map